import {PermissionsState} from '../state/permissionsState';
import {Fetch_All_Permissions_Data, Update_Permissions_List_Success,
            Permissions_Data_Success,Fetch_Permissions_Request} from '../action/permissionsAction';

export function PermissionsReducer(state = PermissionsState, action) {
    
    switch(action.type){
        case Fetch_All_Permissions_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                permissionsList : action.permissionsList
            })
        case Update_Permissions_List_Success:
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                permissionsList : action.UpdatedList,
                message : action.message
            })
        case Permissions_Data_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.Message,
                UpdatedList : action.list
            })
        case Fetch_Permissions_Request:
            return Object.assign({},state,{
                message : '',
                statusCode : 0
            })
        default:
            return state
    }
}